export * from './selectors/root.selectors';
export * as rootActions from './actions/root.actions';
import { RedirectEffects } from './effects/redirect.effects';
import { RootEffects } from './effects/root.effects';
export const rootEffects: any[] = [RootEffects, RedirectEffects];
